import React, { useEffect, useState } from "react";
import LoadingSpinner from "../components/common/LoadingSpinner";
import { httpReauest } from "../utils/httpRequest";
import { useNavigate } from "react-router-dom";
import {
  FaArrowLeft,
  FaShoppingCart,
  FaUtensils,
  FaHome,
  FaGamepad,
  FaUser,
} from "react-icons/fa";
import { MdLocationOn } from "react-icons/md";
import Layout from "../components/layout";
import motion from "framer-motion";
import GameMap from "../components/layout/GameMap";
import EpisodeSelector from "../components/layout/EpisodeSelector";

const Game = () => {
  const [loading, setLoading] = useState(true);
  const [data, setdata] = useState();
  const [selectedEpisode, setSelectedEpisode] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user) {
      return;
    }
    await httpReauest(
      "GET",
      "/user/info/" + user?._id,
      {},
      { "x-access-token": user?.token }
    )
      .then((res) => setdata(res.data.data?.user))
      .catch(() => {
        localStorage.removeItem("user");
        navigate("/login");
      });
    setLoading(false);
  }

  const handleSelectEpisode = (episode) => {
    setSelectedEpisode(episode);
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="min-h-screen  flex flex-col justify-between text-[var(--primary)] bg-[#FFCA24]">
      <Layout>
        {selectedEpisode ? (
          <GameMap
            user={data}
            episode={selectedEpisode}
            setSelectedEpisode={setSelectedEpisode}
          />
        ) : (
          <EpisodeSelector user={data} onSelectEpisode={handleSelectEpisode} />
        )}
      </Layout>
    </div>
  );
};

export default Game;
